import { render, staticRenderFns } from "./ReviewPageSetupPreview.vue?vue&type=template&id=73285aec&scoped=true&lang=pug&"
import script from "./ReviewPageSetupPreview.vue?vue&type=script&lang=js&"
export * from "./ReviewPageSetupPreview.vue?vue&type=script&lang=js&"
import style0 from "./ReviewPageSetupPreview.vue?vue&type=style&index=0&id=73285aec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73285aec",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VImg } from 'vuetify/lib/components/VImg';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAvatar,VCard,VCol,VDivider,VImg,VProgressCircular,VRow})
